import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as endpoint from '../../../constants/endpoints';
import * as api from '../../../constants/api';

import * as documentsActionCreators from '../../../actions/documents';
import * as headerActionCreators from '../../../actions/header';
let allActionCreators = Object.assign({}, headerActionCreators, documentsActionCreators);


class Viewer extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      manualImg: null,
      loadingImg: true,
      errorImg: false,
    };
  }

  componentDidMount() {
    this._cover.addEventListener('contextmenu', event => this.disableClick(event));

    this.props.documentsFetchManualURL()
    .then((respData) => {
      this.setState({
        manualImg: respData,
        loadingImg: false
      })
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });

  }

  componentWillMount() {
    this.props.headerBack(true);
  }

  componentWillUnmount() {
    this._cover.removeEventListener('contextmenu', event => event.preventDefault(), false);
  }

  disableClick(evt) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  render() {
    return <div className='Viewer'>

      <div className='documentTitle'>Training Manual</div>
      <div className='documentOuterWrapper' ref={(c) => this._cover = c}>
        <div className='documentInnerWrapper'>
          {this.state.manualImg ?
            <img src={api.URL + endpoint.DOCS_MANUAL + '?ak=' + this.state.manualImg} className='documentImg' ref={(c) => this._embed = c} /> :
            null
          }
        </div>
      </div>

    </div>;
  }
}
export default Viewer;

// <div className='documentCover'></div>
// <iframe src='/assets/manual01182018.pdf' className='viewerDocumentHolder'></iframe>

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

export const ViewerContainer = connect(
  mapStateToProps,
  allActionCreators
)(Viewer);


// WEBPACK FOOTER //
// ./src/components/views/documents/Viewer.jsx